import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyMobileCTA from "@/components/layout/StickyMobileCTA";
import SmoothScroll from "@/components/SmoothScroll";
import { trackPageView } from "@/lib/analytics";

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    const t = setTimeout(() => trackPageView(pathname + search), 80);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
}

export default function Layout({ children }) {
  return (
    <SmoothScroll>
      <div className="grain min-h-screen bg-background">
        <ScrollToTop />
        <Header />
        <main className="relative z-10 pb-20 lg:pb-0">{children}</main>
        <Footer />
        <StickyMobileCTA />
      </div>
    </SmoothScroll>
  );
}
